<script lang="ts" setup>
  import { options, type SupportedLocale } from '~/types/localization'

  const i18n = useI18n()

  const handleSelect = async (localeCode: SupportedLocale): Promise<void> => {
    await i18n.setLocale(localeCode)
  }
</script>

<template>
  <div class="flex justify-between gap-8 items-center">
    <p class="text-content-title font-semibold text-sm">{{ $t('common.language') }}</p>
    <div class="flex items-center gap-1 w-full justify-end">
      <div
        v-for="option in options"
        :key="option.key"
        :class="{ 'bg-primary text-white shadow-none': option.key === i18n.locale.value }"
        class="p-1 w-8 rounded-sm cursor-pointer text-content-title text-center border hover:border-primary/40 hover:shadow-none border-primary/30 transition-all duration-300 ease-in-out"
        @click.stop="handleSelect(option.key)"
      >
        <p class="text-xs+">{{ option.label }}</p>
      </div>
    </div>
  </div>
</template>
